import { Button } from 'antd';
import styled from 'styled-components';

export const LogoutButtonStyles = styled(Button)`
  padding: 0;
  display: flex;
  align-items: center;
  color: black;
`;
